import './index.css'

const Skills = () => {
    return (    
        <div id="skills">
        <h2 class="heading">Skills</h2>
        <ul>
            <li>Python</li>
            <li>C/C++</li>
            <li>Java</li>
            <li>JavaScript</li>
            <li>HTML</li>
            <li>CSS</li>
            <li>MATLAB</li>
            <li>OpenCV</li>
            <li>CUDA</li>
            <li>Scikit-learn</li>
            <li>Numpy</li>
            <li>Pandas</li>
            <li>Librosa</li>
            <li>Pytorch</li>
            <li>TensorFlow</li>
            <li>Keras</li>
            <li>React</li>
            <li>Django</li>
            <li>React Native</li>
            <li>Google Cloud</li>
            <li>Cloudflare</li>
            <li>OpenSea</li>
                        
        </ul>
    </div>
    );
};

export default Skills